<span class="ui-avatar-group" [attr.aria-label]="membersLabel()">
  @for (member of visible(); track member.name) {
    <ui-avatar [name]="member.name" [src]="member.src ?? ''" size="sm" />
  }
  @if (hiddenCount() > 0) {
    <span class="ui-avatar-group__extra">+{{ hiddenCount() }}</span>
  }
</span>
